// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const KIPS_BIO_PHARMA_FIELD_ALIASES = {
  hospitalName: ['거래처명'],
  drugName: ['품명'],
  unitPrice: ['단가'],
  quantity: ['수량'],
  prescriptionAmount: ['합계'],
  feeRate: ['수수료'],
  settlementAmount: ['확정액'],
};

const REQUIRED_HEADERS = [
  '거래처명',
  '일자',
  '품명',
  '규격',
  '수량',
  '단가',
  '합계',
  '수수료',
  '확정액',
];

function isKipsBioPharmaProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const kipsBioPharmaTemplate = {
  id: 'kips-bio-pharma',
  name: '킵스바이오파마 템플릿',
  match(context) {
    return context.headerProfiles.some(isKipsBioPharmaProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isKipsBioPharmaProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(KIPS_BIO_PHARMA_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '킵스바이오파마';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: row[columnMap.hospitalName],
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default kipsBioPharmaTemplate;
